"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var icons = {
    recent: '/img/game-filters/recent.svg',
    favorites: '/img/game-filters/favorites.svg',
    all: '/img/game-filters/all.svg',
    recentHover: '/img/game-filters/hover/recent.svg',
    favoritesHover: '/img/game-filters/hover/favorites.svg',
    allHover: '/img/game-filters/hover/all.svg',
};
exports.default = icons;
